// Tipologie impianto fotovoltaico
export const PLANT_TYPES = {
    residenziale: 'Residenziale',
    aziendale: 'Aziendale',
    agrisolare: 'Agrisolare',
    altro: 'Altro'
};
